import './App.css'
import './app/assets/styles/general.scss'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, Provider, useSelector } from 'react-redux'
import { setlauncherContent, setShowLuancher } from 'app/redux/widget/widget.actions'
import 'animate.css'
import { setActiveDepartment, recordRoadmapCheckpoint } from './app/redux/messages/messages.actions'
import { fetchWidgetInfoStart } from 'app/redux/widget/widget.actions'
import { store } from './app/redux/createStore'
import { LAUNCHER_CONTENT_STATE } from 'app/constants/launcherContentStates'
import { darkenHexColor } from 'app/utils/color'
import useMediaQuery from 'app/hooks/useMediaQuery'
// import { WALLPAPERS } from 'app/constants/wallpapers'
import useLinger from './app/hooks/useLinger'
import useWidgetApi from 'app/hooks/useWidgetApi'
import { showAlwaysFullScreen } from 'app/utils/screen'
import Luancher from 'app/containers/widget/launcher/main'
import './appStyles.scss'
import useAutoMessages from 'app/hooks/useAutoMessages'
import { getHostWebsiteUrl } from 'app/utils/links'

const getWidgetInfo = ({ widgetData }) => widgetData.widgetInfo
const getShowLauncher = ({ widgetData }) => widgetData.widgetInfo.showLauncher
const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo
const getDepartments = ({ widgetData }) => widgetData.widgetInfo.data?.teams
const getFaqs = ({ widgetData }) => widgetData.widgetInfo.faq
const getIsWidgetWideOpen = ({ widgetData }) => widgetData.widgetInfo.isWidgetWideOpen
const getTriggerData = ({ widgetData }) => widgetData.widgetInfo.data?.trigger
const getShowTrigger = ({ widgetData }) => widgetData.widgetInfo.showTrigger
const getSelectedQuestion = ({ messagesData }) => messagesData.selectedQuestion
const getChannelId = ({ widgetData }) => widgetData.widgetInfo.data?.channel?.id
const getMessagesData = ({ messagesData }) => messagesData
const getShowWidget = ({ widgetData }) => widgetData.widgetInfo.showWidget
const getInjectedPosition = ({ widgetData }) => widgetData.widgetInfo.injectedPosition
const getIsAiBotEnabled = ({ widgetData }) => widgetData.widgetInfo.aiBotEnabled
const getActiveAutoMsg = ({ widgetData }) => widgetData.activeTriggerMsg

const LAUNCHER_OPEN_IN_MOBILE_CLASSNAME = 'raychat-widget-mobile-open'

function App() {
  const dispatch = useDispatch()

  const widgetInfo = useSelector(getWidgetInfo)

  const showLauncher = useSelector(getShowLauncher)
  const languageInfo = useSelector(getLanguageInfo)
  const departments = useSelector(getDepartments)
  const faqs = useSelector(getFaqs)
  const isWidgetWideOpen = useSelector(getIsWidgetWideOpen)
  const triggerData = useSelector(getTriggerData)
  const showTrigger = useSelector(getShowTrigger)
  const selectedQuestion = useSelector(getSelectedQuestion)
  const channel_id = useSelector(getChannelId)
  const messagesData = useSelector(getMessagesData)
  const showWidget = useSelector(getShowWidget)
  const injectedPosition = useSelector(getInjectedPosition)
  const aiBotEnabled = useSelector(getIsAiBotEnabled)
  const activeAutoMsg = useSelector(getActiveAutoMsg)

  const { direction = 'rtl' } = languageInfo.general || {}
  const [widgetPosition, setWidgetPosition] = useState(null)

  const observer = useRef(null)
  const smallWidth = useMediaQuery('(max-width: 700px)')
  const isMobileView = useMediaQuery('(max-width: 450px)')
  const showFullscreen = showAlwaysFullScreen(channel_id)

  useAutoMessages()
  useLinger(messagesData, widgetInfo.data?.lingers, aiBotEnabled)
  useWidgetApi()

  const verticalOffset =
    (widgetPosition?.topSpace !== 'auto' && widgetPosition?.topSpace) ||
    (widgetPosition?.bottomSpace !== 'auto' && widgetPosition?.bottomSpace) ||
    '0px'

  const getFramePosition = () => {
    const disableStyle = `
      .raychat_frame{
        position: fixed;
        z-index: 0;
        width: 0; 
        height: 0; 
        border: 0;
        color-scheme: none;
      }`

    const fullscreenStyle = `
      .raychat_frame{
        position: fixed;
        z-index: 2000000000;
        width: 100%; 
        height: 100%; 
        border: 0;
        color-scheme: none;
        top : 0px;
        left : 0px;
        bottom: 0px;
        right: 0px;
      }`

    const triggerStyle = `
      .raychat_frame{
        position: fixed;
        z-index: 2000000000;
        width: 100px; 
        height: 100px; 
        max-height: 714px;  
        border: 0;
        color-scheme: none;
        top : ${
          widgetPosition?.topSpace
            ? widgetPosition?.topSpace !== 'auto'
              ? `calc(${widgetPosition?.topSpace} - 20px)`
              : 'auto'
            : 'auto'
        };
        left : ${
          widgetPosition?.leftSpace
            ? widgetPosition?.leftSpace !== 'auto'
              ? `calc(${widgetPosition?.leftSpace} - 20px)`
              : 'auto'
            : 'auto'
        };
        bottom: ${
          widgetPosition?.bottomSpace
            ? widgetPosition?.bottomSpace !== 'auto'
              ? `calc(${widgetPosition?.bottomSpace} - 20px)`
              : 'auto'
            : '-5px'
        }; 
        right: ${
          widgetPosition?.rightSpace
            ? widgetPosition?.rightSpace !== 'auto'
              ? `calc(${widgetPosition?.rightSpace} - 20px)`
              : 'auto'
            : '-5px'
        };
        border-radius : 12px;
        box-shadow : none;
      }`

    const launcherStyle = `
      .raychat_frame{
        position: fixed;
        z-index: 2000000000;
        width: ${isWidgetWideOpen ? '688px' : '366px'}; 
        height: 714px;
        max-height: min(714px, 100% - calc(${verticalOffset} + 15px));
        border: 0;
        color-scheme: none;
        top : ${widgetPosition?.topSpace || 'auto'};
        left : ${widgetPosition?.leftSpace || 'auto'};
        bottom: ${widgetPosition?.bottomSpace || '15px'}; 
        right: ${widgetPosition?.rightSpace || '15px'};
        border-radius : 12px;
        box-shadow : 0 5px 40px rgba(0, 0, 0, .16);
      }`

    const greetingStyle = `    
      .raychat_frame{
        position: fixed;
        z-index: 2000000000;
        width: ${isMobileView ? '340px' : '455px'} ; 
        height: ${200 + (widgetInfo.autoMessageContentSize === 0 ? 90 : widgetInfo.autoMessageContentSize)}px;
        max-height: 714px;  
        border: 0;
        color-scheme: none;
        top : ${widgetPosition?.topSpace ? `calc(${widgetPosition?.topSpace} - 20px)` : 'auto'};
        left : ${widgetPosition?.leftSpace ? `calc(${widgetPosition?.leftSpace} - 20px)` : 'auto'};
        bottom: ${widgetPosition?.bottomSpace ? `calc(${widgetPosition?.bottomSpace} - 20px)` : '-5px'}; 
        right: ${widgetPosition?.rightSpace ? `calc(${widgetPosition?.rightSpace} - 20px)` : '-5px'};
        border-radius : 12px;
        box-shadow : none;
      }`

    if (!showWidget) return disableStyle

    if ((isMobileView && showLauncher) || (showLauncher && showFullscreen)) return fullscreenStyle

    if (showTrigger && activeAutoMsg && !showLauncher) return greetingStyle

    if (!showLauncher) return triggerStyle

    return launcherStyle
  }

  const getStyleVariables = () => {
    const personalizeData = widgetInfo.data.personalize

    return {
      '--header-expand-height': `${widgetInfo.headerExpandHeight}px`,
      '--tertiary-color': personalizeData.headerTitleColor,
      '--primary-color': personalizeData.bgc,
      '--secondary-color': personalizeData.seColor,
      '--primary-color-dark': darkenHexColor(personalizeData.bgc, 40),
      '--widget-right-position': widgetPosition.rightSpace || '15px ',
      '--widget-left-position': widgetPosition.leftSpace || 'auto',
      '--widget-bottom-position': widgetPosition.bottomSpace || '15px',
      '--widget-top-position': widgetPosition.topSpace || 'auto',
      '--trigger-right-position': !widgetPosition.rightSpace
        ? '65px'
        : widgetPosition.rightSpace !== 'auto' && `${parseInt(widgetPosition.rightSpace, 10) + 50}px`,
      '--trigger-left-position': !widgetPosition.leftSpace
        ? 'auto'
        : widgetPosition.leftSpace !== 'auto' && `${parseInt(widgetPosition.leftSpace, 10) + 50}px`,
      '--trigger-top-position': !widgetPosition.topSpace
        ? 'auto'
        : widgetPosition.topSpace !== 'auto' && `${parseInt(widgetPosition.topSpace, 10) + 70}px`,
      '--trigger-bottom-position': !widgetPosition.bottomSpace
        ? '85px'
        : widgetPosition.bottomSpace !== 'auto' && `${parseInt(widgetPosition.bottomSpace, 10) + 70}px`,
      '--launcher-top-position': !widgetPosition.topSpace
        ? 'auto'
        : widgetPosition.topSpace !== 'auto' && `${parseInt(widgetPosition.topSpace, 10) + 10}px`,
      '--launcher-bottom-position': !widgetPosition.bottomSpace
        ? '85px'
        : widgetPosition.bottomSpace !== 'auto' && `${parseInt(widgetPosition.bottomSpace, 10) + 10}px`,
      '& .app': { direction: `${direction}` },
      '--greeting-trigger-right-position': widgetPosition.rightSpace
        ? widgetPosition.rightSpace !== 'auto'
          ? '0px'
          : 'auto'
        : '0px',
      '--greeting-trigger-left-position': widgetPosition.leftSpace
        ? widgetPosition.leftSpace !== 'auto'
          ? '0px'
          : 'auto'
        : 'auto',
      '--greeting-trigger-bottom-position': widgetPosition.bottomSpace
        ? widgetPosition.bottomSpace !== 'auto'
          ? '0px'
          : 'auto'
        : '0px',
      '--greeting-trigger-top-position': widgetPosition.topSpace
        ? widgetPosition.topSpace !== 'auto'
          ? '0px'
          : 'auto'
        : 'auto',

      '--greeting-content-right-position': widgetPosition.rightSpace
        ? widgetPosition.rightSpace !== 'auto'
          ? '60px'
          : 'auto'
        : '60px',
      '--greeting-content-left-position': widgetPosition.leftSpace
        ? widgetPosition.leftSpace !== 'auto'
          ? '75px'
          : 'auto'
        : 'auto',
      '--greeting-content-bottom-position': widgetPosition.bottomSpace
        ? widgetPosition.bottomSpace !== 'auto'
          ? '85px'
          : 'auto'
        : '85px',
      '--greeting-content-top-position': widgetPosition.topSpace
        ? widgetPosition.topSpace !== 'auto'
          ? '85px'
          : 'auto'
        : 'auto',
      // Note: wallpapers features temporarly disabled because of new designs
      // '--widget-wallpaper':
      //   personalizeData.wallpaper === '1' ? 'none' : WALLPAPERS[+personalizeData.wallpaper - 2].value,
      '--header-logo-bg':
        personalizeData.backgroundLogo && personalizeData.backgroundLogo !== 'null'
          ? personalizeData.backgroundLogo
          : 'transparent',
      '--widget-trigger-bg-color': getWidgetBgColor(),
      '--cover-widget-logo-bg-color': getCoverLogoBgColor(),
    }
  }

  // check page navigation on SPAs and fetch widget infos on every route change.
  useEffect(() => {
    let previousUrl = getHostWebsiteUrl()

    observer.current = new MutationObserver(function () {
      if (getHostWebsiteUrl() !== previousUrl) {

        if (previousUrl) {
          dispatch(fetchWidgetInfoStart())
          dispatch(
            recordRoadmapCheckpoint({
              previousUrl,
              currentUrl: getHostWebsiteUrl(),
            }),
          )
        }

        previousUrl = getHostWebsiteUrl()
      }
    })

    observer.current.observe(window.parent.document, {
      subtree: true,
      childList: true,
    })

    return () => observer.current.disconnect()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // close widget launcher when hitting browser back btn on mobile view
  useEffect(() => {
    const handleBackButton = (event) => {
      // Cancel the default back button behavior
      event.preventDefault()

      // Perform custom actions
      dispatch(setShowLuancher(false))
    }

    // Add the event listener when the widget is in mobile view
    if (smallWidth) window.parent.addEventListener('popstate', handleBackButton)

    // Remove the event listener when the component unmounts
    return () => {
      if (smallWidth) window.parent.removeEventListener('popstate', handleBackButton)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [smallWidth])

  useEffect(() => {
    if (showLauncher && smallWidth) {
      window.parent.history.pushState(null, null, getHostWebsiteUrl())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showLauncher])

  useEffect(() => {
    const showMainCover = faqs?.length > 0 || departments?.length > 1

    // mainCover
    if (showMainCover) {
      dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.MAIN_COVER))
    } else {
      const departmentId = departments?.[0]?._id

      if (departmentId) dispatch(setActiveDepartment(departmentId))

      dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.FIRST_CHAT))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departments, faqs])

  const getWidgetBgColor = () => {
    const logoBg = widgetInfo.data.personalize.backgroundLogo
    const primary = widgetInfo.data.personalize.bgc

    if (logoBg && logoBg !== 'null' && logoBg !== 'transparent') return logoBg

    return primary
  }

  const getCoverLogoBgColor = () => {
    const logoBg = widgetInfo.data.personalize.backgroundLogo
    const primary = widgetInfo.data.personalize.bgc

    if (logoBg && logoBg !== 'null') return logoBg

    return primary
  }

  useEffect(() => {
    if (widgetInfo.data) {
      const initialDefaultPosition = widgetInfo.data.personalize.position
      const position = injectedPosition || initialDefaultPosition

      setWidgetPosition(position)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetInfo.data, injectedPosition])

  useEffect(() => {
    const languageDirection = languageInfo?.general?.direction

    if (languageDirection) {
      document.body.setAttribute('dir', languageDirection)
    }
  }, [languageInfo])

  useEffect(() => {
    if (widgetPosition) {
      const pd = window.parent.document // parent doc
      const frameStylesContent = getFramePosition()
      const frameStyles = pd.getElementById('raychat_frame_styles')
      if (frameStyles) {
        frameStyles.textContent = frameStylesContent
      } else {
        const stag = pd.createElement('style')
        stag.id = 'raychat_frame_styles'
        stag.appendChild(pd.createTextNode(frameStylesContent))
        pd.getElementsByTagName('head')[0]?.appendChild(stag)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isWidgetWideOpen,
    showLauncher,
    showTrigger,
    triggerData,
    widgetPosition,
    isMobileView,
    selectedQuestion,
    showWidget,
    widgetInfo.autoMessageContentSize,
  ])

  useEffect(() => {
    if (showLauncher) {
      const iframe = window.parent.document.getElementById('raychat_widget')
      setTimeout(() => {
        if (iframe) iframe.style.transition = 'width 250ms, height 250ms'
      }, 300)
    } else {
      const iframe = window.parent.document.getElementById('raychat_widget')
      if (iframe) iframe.style.transition = 'none'
    }
  }, [showLauncher])

  // toggles mobile style rules in parent website body
  useEffect(() => {
    if (!isMobileView) return

    const parentSiteDocument = window.parent.document
    if (!parentSiteDocument) return

    const bodyElement = parentSiteDocument?.body
    if (!bodyElement) return

    const classList = bodyElement.classList

    if (showLauncher && !classList.contains(LAUNCHER_OPEN_IN_MOBILE_CLASSNAME)) {
      classList.add(LAUNCHER_OPEN_IN_MOBILE_CLASSNAME)
    }

    if (!showLauncher && classList.contains(LAUNCHER_OPEN_IN_MOBILE_CLASSNAME)) {
      classList.remove(LAUNCHER_OPEN_IN_MOBILE_CLASSNAME)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showLauncher])

  // TODO: it's better to gather all raychat rules (together with raychat_frame_styles) in one style Element
  // adds  style element to parent host site. style rules prevent background scroll when widget is in mobile devices
  useEffect(() => {
    const parentSiteDocument = window.parent.document

    if (parentSiteDocument) {
      const cssRules = `body.${LAUNCHER_OPEN_IN_MOBILE_CLASSNAME} {overflow: hidden;}`
      const styleElement = document.createElement('style')
      styleElement.id = 'raychat_mobile_style_rules'

      if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = cssRules
      } else {
        styleElement.appendChild(document.createTextNode(cssRules))
      }

      parentSiteDocument.head?.append(styleElement)
    }
  }, [])

  if (!(widgetInfo.data && widgetPosition)) {
    return null
  }

  return (
    <div style={getStyleVariables()}>
      <div className="app">{showWidget && <Luancher />}</div>
    </div>
  )
}

const WrappedApp = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

export default WrappedApp
